export default function MySQL_LAST_DAY() {
  return (
    <div>
      <h2>MySQL_LAST_DAY</h2>    </div>
  );
}